import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-divLoader',
  templateUrl: './divLoader.component.html',
  styleUrls: ['./divLoader.component.scss']
})
export class divLoaderComponent {
  @Input() loading: boolean = false;  
}
